import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkle } from "@phosphor-icons/react";
import { Switch } from "@/components/ui/switch";
import { getSaleApi, setSaleApi, formatApiErrorDetail } from "@/lib/api";

export function SaleSettings() {
  const [sale, setSale] = useState(null);
  const [pct, setPct] = useState(30);
  useEffect(() => { getSaleApi().then((s) => { setSale(s); setPct(s.percent); }).catch(() => {}); }, []);
  if (!sale) return null;

  const save = async (body, msg) => {
    try { const s = await setSaleApi(body); setSale(s); setPct(s.percent); toast.success(msg); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); setPct(sale.percent); }
  };

  return (
    <div className="stp-card mb-8 flex flex-col gap-4 rounded-3xl p-6 sm:flex-row sm:items-center sm:justify-between" data-testid="sale-settings">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-[#FF9F0A] to-[#FF2D55] text-white"><Sparkle size={20} weight="fill" /></span>
        <div>
          <p className="font-semibold text-ink">{sale.name} · code {sale.code}</p>
          <p className="text-xs text-mist" data-testid="sale-status-text">{sale.active ? `Live: ${sale.percent}% off every plan, shown on the landing and pricing pages.` : "Off: customers see regular prices."}</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <label className="flex items-center gap-1.5 text-xs text-mist">
          Discount
          <input data-testid="sale-percent-input" type="number" min={1} max={90} value={pct} onChange={(e) => setPct(e.target.value)} className="h-9 w-16 rounded-xl border border-black/10 px-2 text-sm text-ink outline-none focus:border-brand" />%
        </label>
        <button data-testid="sale-percent-save" onClick={() => save({ percent: Number(pct) }, "Discount updated")} className="h-9 rounded-full bg-black/5 px-3 text-xs font-medium text-ink hover:bg-black/10">Save</button>
        <label className="flex items-center gap-2 text-sm font-medium text-ink">
          <Switch data-testid="sale-active-switch" checked={sale.active} onCheckedChange={(v) => save({ active: v }, v ? "Sale is live" : "Sale turned off")} /> {sale.active ? "On" : "Off"}
        </label>
      </div>
    </div>
  );
}
